import { render } from "./UserListView.vue?vue&type=template&id=54b7850f&scoped=true"
import script from "./UserListView.vue?vue&type=script&lang=js"
export * from "./UserListView.vue?vue&type=script&lang=js"

import "./UserListView.vue?vue&type=style&index=0&id=54b7850f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b7850f"]])

export default __exports__